import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { skipAutoConfirmOnce, useLongPress } from '../store/helpers';
import ConfirmationModal from '../components/ConfirmationModal';
import { getTranslation } from '../translations';
const AppLayout = ({ children, }) => {
    const [showModal, setShowModal] = useState(false);
    const labels = getTranslation();
    const handleBackToSetup = () => {
        setShowModal(false);
        skipAutoConfirmOnce();
        window.location.reload();
    };
    useLongPress(() => {
        setShowModal(true);
    }, { delay: 5000 });
    return (_jsxs("div", { className: 'flex flex-col justify-center items-center min-h-screen bg-[var(--primary-color,var(--color-primary))]', children: [_jsx("div", { className: 'w-full max-w-4xl p-4 short:p-2', children: children }), showModal && (_jsx(ConfirmationModal, { title: labels.backToSetup, message: labels.backToSetupQuestion, onConfirm: handleBackToSetup, onCancel: () => setShowModal(false) }))] }));
};
export default AppLayout;
